import { createRoot } from 'react-dom/client';
import { App } from './App';
import { cleanupLegacyServiceWorkers } from '@/lib/serviceWorkerCleanup';
import './index.css';

// #2133 設計 §5 手順1: 今の Flutter Web が入れている Service Worker を解除し、
// 古いキャッシュを消す。React 版の起動時に一度だけ実行する。
void cleanupLegacyServiceWorkers();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(<App />);
